import React, { useState } from 'react';
import "./InputField.scss";
import { useFormContext, FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

interface InputFieldProps {
  label: string;
  name: string;
  type: string;
  size?: 'small' | 'medium' | 'large' | 'full' | 'addTeacherField' | 'addClassroomField' | 'fullS' | 'fullSUpper';
  classname?: string;
  isDisable?:boolean;
  optional?: boolean;
  page?:string;
  onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<InputFieldProps> = ({ page, optional, label, name, type, size = 'medium', classname = "", isDisable = false, onInput }) => {
  const { register, formState: { errors } } = useFormContext();
  const [showPassword, setShowPassword] = useState(false);

  //Password toggle function
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  //Error Message Type function
  const getErrorMessage = (
    error: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined
  ): string | null => {
    if (typeof error === 'string') {
      //string type
      return error;
    }
    if (error && 'message' in error && typeof error.message === 'string') {
      //object type
      return error.message;
    }
    return null;
  };

  const getNestedError = (error: any, name: string) => {
    const names = name.split('.');
    let currentError = error;

    for (const n of names) {
      if (currentError[n]) {
        currentError = currentError[n];
      } else {
        return null;
      }
    }

    return currentError;
  };

  const error = getNestedError(errors, name);
  const errorMessage = getErrorMessage(error);

  return (
    <div className={`input-container ${size} ${classname} ${type === "password" ? 'eyeIconPadding' : ''}`}>
      <div className='input-field'>
      {type !== "textarea" && <input
        id={name}
        {...register(name)}
        type={type === "password" && !showPassword ? "password" : "text"}
        placeholder={label}
        className={`field ${name === 'referralcode' ? 'referralCode' : ''}`}
        disabled={isDisable}
        autoComplete='new-password'
        {...(onInput ? { onInput: (e) => onInput(e) } : {})}
      />}
      {type === "password" && (
        showPassword ? (
          <div className={`eye-on ${size}`} onClick={handleTogglePasswordVisibility} />
        ) : (
          <div className={`eye-off ${size}`} onClick={handleTogglePasswordVisibility} />
        )
      )}
      {type === "textarea" &&
        <textarea
        id={name}
        {...register(name)}
        placeholder={label}
        className="field no-resize"
        disabled={isDisable}
      />
      }
      </div>
      {errorMessage && <span className="error-message">{errorMessage}</span>}
      {/*
      To show optional text, under the field
       {
        optional ?
        <div className='errorWithOptionalText'>
          {errorMessage && <div className='errorContainer' style={{paddingLeft: page === 'student' ? '12px' : ''}}><span className="error-message">{errorMessage}</span></div>}
          <div className='optionalText'><div>*optional</div></div>
        </div>
        :
        errorMessage && <div className='errorContainer' style={{paddingLeft: page === 'student' ? '12px' : ''}}><span className="error-message">{errorMessage}</span></div>
      } */}
    </div>
  );
};

export default InputField;
